/**
 * Trinco ENTRE ABAS do mesmo navegador (faixa 25 §2): no máximo uma renovação — e a troca de senha, o
 * logout e o logout-all — por vez. Ver `trinco.md`.
 */
export const NOME_DO_TRINCO = 'omni-refresh'

export interface OpcoesDoTrinco {
  /**
   * Teto da ESPERA pela concessão, em ms. Estourou antes de conceder → rejeita com `DOMException` `AbortError`
   * e a seção não roda. Concedido a tempo, o prazo para de contar (a seção cuida do próprio teto).
   * Ausente = espera o quanto for.
   */
  prazoMs?: number
}

export interface Trinco {
  segurar<T>(secao: () => Promise<T>, opcoes?: OpcoesDoTrinco): Promise<T>
}

let injetado: Trinco | null = null

/** Só teste (`src/test/abasFalsas.ts`): troca a implementação. `null` volta à real. */
export function definirTrinco(trinco: Trinco | null): void {
  injetado = trinco
}

function semTrinco<T>(secao: () => Promise<T>): Promise<T> {
  return secao()
}

function trincoReal(): Trinco {
  const locks: LockManager | undefined =
    typeof navigator === 'undefined' ? undefined : (navigator as { locks?: LockManager }).locks
  // Sem Web Locks OU sem BroadcastChannel: sem trinco (spec §2). Quem esperasse o trinco sem canal nunca
  // receberia o access de quem renovou e renovaria logo atrás de qualquer jeito. A graça de 30 s do back
  // cobre a corrida (R38).
  if (!locks || typeof BroadcastChannel !== 'function') return { segurar: semTrinco }
  return {
    async segurar<T>(secao: () => Promise<T>, opcoes?: OpcoesDoTrinco): Promise<T> {
      let resultado!: T
      if (opcoes?.prazoMs === undefined) {
        await locks.request(NOME_DO_TRINCO, async () => {
          resultado = await secao()
        })
        return resultado
      }
      // `signal` abortado ANTES da concessão rejeita o `request` com AbortError (MDN, LockManager.request());
      // depois da concessão não tem efeito — mesmo assim o relógio para ao conceder.
      const controle = new AbortController()
      const relogio = setTimeout(() => controle.abort(), opcoes.prazoMs)
      try {
        await locks.request(NOME_DO_TRINCO, { signal: controle.signal }, async () => {
          clearTimeout(relogio)
          resultado = await secao()
        })
      } finally {
        clearTimeout(relogio)
      }
      return resultado
    },
  }
}

export function segurarTrinco<T>(secao: () => Promise<T>, opcoes?: OpcoesDoTrinco): Promise<T> {
  return (injetado ?? trincoReal()).segurar(secao, opcoes)
}
